<template>
  <div class="common-table-container" :style="{ height: tableContainerHeight }">
    <div class="table-wrapper" :style="{ height: tableWrapperHeight, paddingBottom: '7vh' }">
      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :rowKey="rowKey || (record => record.id)"
        :pagination="false"
        bordered
        :scroll="dataSource.length > 0 ? { x: 1200, y: tableBodyHeight } : { x: 1200 }"
        class="full-center-table"
        :rowSelection="rowSelection"
      >
        <template 
          v-for="(_, slotName) in $scopedSlots" 
          :slot="slotName" 
          slot-scope="scope"
        >
          <slot :name="slotName" v-bind="scope" />
        </template>
      </a-table>
    </div>
    <div class="pagination-container" v-if="total > 0">
      <a-pagination
        :current="currentPage"
        :pageSize="pageSize"
        :total="total"
        :showSizeChanger="showSizeChanger"
        :showTotal="() => `共 ${total} 条记录`"
        @change="handlePageChange"
        @showSizeChange="handleSizeChange"
        style="text-align: right"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonTable',
  props: {
    columns: { type: Array, required: true },
    dataSource: { type: Array, required: true },
    loading: { type: Boolean, default: false },
    total: { type: Number, default: 0 },
    rowKey: { type: Function, default: null },
    showSizeChanger: { type: Boolean, default: true },
    currentPage: { type: Number, default: 1 },
    pageSize: { type: Number, default: 10 },
    tableHeight: { type: [Number, String], default: 70 },
    extraParams: { type: Object, default: () => ({}) },
    // 新增：接收 rowSelection 属性（用于复选框配置，非必传，默认 null）
    rowSelection: { type: Object, default: null }
  },
  computed: {
    tableContainerHeight() {
      return typeof this.tableHeight === 'number' ? `${this.tableHeight}vh` : this.tableHeight;
    },
    tableWrapperHeight() {
      const heightNum = typeof this.tableHeight === 'number' ? this.tableHeight : parseInt(this.tableHeight);
      return `${heightNum - 12}vh`;
    },
    tableBodyHeight() {
      const wrapperHeight = parseInt(this.tableWrapperHeight);
      return `${wrapperHeight - 7}vh`;
    }
  },
  methods: {
    handlePageChange(page, pageSize) {
      this.$emit('pageChange', page, pageSize || this.pageSize, this.extraParams);
    },
    handleSizeChange(current, size) {
      this.$emit('sizeChange', 1, size, this.extraParams);
    },
    triggerRefresh() {
      this.$emit('refresh', this.currentPage, this.pageSize, this.extraParams);
    },
    triggerReset() {
      this.$emit('reset', 1, this.pageSize, this.extraParams);
    }
  }
};
</script>

<style scoped>
.common-table-container {
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #fff;
}
.table-wrapper {
  width: 100%;
  overflow: hidden;
}
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.empty-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 100%;
}
</style>
<style>
.full-center-table .ant-table-thead > tr > th {
  background: #1890ff !important;
  color: #ffffff !important;
  height: 35px;
  line-height: 35px;
  font-size: 20px;
}
</style>